import { createStyles, makeStyles } from '@material-ui/core';
import { ExtendedTheme, MessageView } from 'neon-design-system';
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { baseUrls } from '../../../utils/baseUrls.utils';
import { getChannelLink } from '../../../utils/link.utils';
import { EmailNeonSales } from '../../ui/EmailNeonSales';

const useStyles = makeStyles<ExtendedTheme>((theme) => createStyles({
	root: {
		display: 'flex',
		height: 'calc(100vh - 212px)',
		alignItems: 'center',
		[theme.breakpoints.down('xs')]: {
			paddingTop: theme.spacing(4)
		}
	}
}));

export const PremiumChannelSubscribeInterestConfirmation = () => {
	const history = useHistory();
	const classes = useStyles();
	const { channelId } = useParams<{ channelId: string }>();
	const isTrial = window.location.href.indexOf('?trial') > -1;
	return <div className={classes.root}>
		<MessageView
			styleName={isTrial ? 'success' : 'primary'}
			title={isTrial ? 'Thank you for registering your interest in a free trial' : 'Get in touch with Sales to discuss buying options'}
			primaryAction={{
				label: isTrial ? 'View channel' : 'Return to insights',
				onClick: () => history.push(isTrial ? getChannelLink(channelId) : baseUrls.forYou),
				styleName: isTrial ? 'success' : 'primary'
			}}
		>
			{isTrial
				? <>The Sales Team will be in touch with you shortly to set up your access.</>
				: <>
					<p>If you are interested in buying the subscription now, please get in touch with our sales team to discuss payment options.</p>
					<p>If you need further assistance, you can email us at <EmailNeonSales /></p>
				</>
			}
		</MessageView>
	</div>
}
